import {medicineReferences} from "../../../../hooks/medicineReferences.mjs";
import { Link, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import useAdminMedicineData from "../../../../hooks/useAdminMedicineData";
import {enrichMedicineCatalogue} from "../../../../hooks/medicineCatalogue.mjs";
import {axiosInstance} from "../../../../config";
import { MedicineLanguageTabs, useMedicineWorkspace } from "../../../../components/adminPanel/shared/MedicineWorkspace";
import MedicineAiRecovery from '../../../../components/adminPanel/shared/MedicineAiRecovery';
import { recoverableMedicineStatuses } from '../../../../hooks/medicineAiRecovery.mjs';
import MedicineSaveFeedback from "../../../../components/adminPanel/shared/MedicineSaveFeedback";
import MedicineAdditionalPreview from "../../../../components/adminPanel/shared/MedicineAdditionalPreview";
import TranslationCatalogue from "../../../../components/adminPanel/shared/TranslationCatalogue";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Grid from "@mui/material/Grid";
import {
  Box,
  Alert,
  Button,
  CardMedia,
  Chip,
  Divider,
  FormControl,
  IconButton,
  MenuItem,
  Select,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Tooltip,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions,
  Stack,
  Pagination,
  LinearProgress,
  InputLabel,
} from "@mui/material";
// Icon
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import InfoIcon from "@mui/icons-material/Info";
import CallMadeIcon from "@mui/icons-material/CallMade";
// react-lazy-load-image
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { PF } from "../../../../config";
import ReactPlayer from "react-player";
// Media Query
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

import SearchFilterBar from "../../../../components/adminPanel/shared/SearchFilterBar";
import PageHeader from "../../../../components/adminPanel/shared/PageHeader";
import SectionLabelChip from "../../../../components/adminPanel/shared/SectionLabelChip";
import EmptyStateAlert from "../../../../components/adminPanel/shared/EmptyStateAlert";
import { colors, radii, shadows, fonts } from "../../../../theme/designTokens";
import MedicineVideoDialog from "../dialog/MedicineVideoDialog";
import CustomVideoPlayer from "../../../../components/misc/CustomVideoPlayer";
import { ExpandMore, Info } from "@mui/icons-material";
import PriceInfoPanel from "./PriceInfoPanel";
import AddLangDialog from "../dialog/AddLangDialog";
// import { medData } from "../data/medData";
import AddMedicineDialog from "../dialog/AddMedicineDialog";
import {
  getAdminMedicineCatalogue,
  removeSingleMedicine,
} from "../../../../reduxToolkit/features/adminPanel/medicine";
import { getNotification } from "../../../../reduxToolkit/features/adminPanel/notification";
import { formatDistance } from "date-fns";
import EditMedicineDialog from "../dialog/EditMedicineDialog";
import LoadingBox from "../../../../components/misc/Loading";
import { getExactTime } from "../../../../hooks/getCreatedData";
import { makeUrlFriendly } from "../../../../hooks/makeUrlFriendly";
import { buildFrontendUrl } from "../../../../hooks/langAlias";
import { formatMedicinePackSize } from "../../../../hooks/formatMedicinePackSize";

export default function ManageMedicine({ routeLanguage, routeEntryId }) {
  const location = useLocation();
  const navigate = useNavigate();
  const medicineWorkspace = useMedicineWorkspace(), review = medicineWorkspace?.review;
  const reviewActive = Boolean(review);
  const reviewSeed = review?.data?.seedByLanguage?.[routeLanguage];
  const [params, setParams] = useSearchParams();
  const base = location.pathname.split("/medicines")[0] + "/medicines";
  const adding = /\/new$/.test(location.pathname);
  const editing = !!routeEntryId;
  const returnParams = new URLSearchParams(location.search);
  for (const key of ['seoWorkspace','seoGeneration','seoReview','source','draft']) returnParams.delete(key);
  if (routeEntryId) returnParams.set("focus", routeEntryId);
  const listQuery = returnParams.toString() ? `?${returnParams}` : "";
  const listUrl = `${base}/${routeLanguage || "en"}${listQuery}`;
  const patchParams = (values, replace = false) => setParams(previous => {
    const next = new URLSearchParams(previous);
    Object.entries(values).forEach(([key, value]) => value === null ? next.delete(key) : next.set(key, String(value)));
    return next;
  }, { replace });
  // Media Query
  const theme = useTheme();
  const smUp = useMediaQuery(theme.breakpoints.up("sm"));
  const mdUp = useMediaQuery(theme.breakpoints.up("md"));
  // use States
  const loading = false;
  const [refreshing,setRefreshing]=useState(false),[refreshError,setRefreshError]=useState("");
  async function refreshCatalogue(){if(refreshing)return;setRefreshing(true);setRefreshError("");try{await catalogueState.refresh();}catch{setRefreshError("The list could not be refreshed. Your existing list and position were preserved.");}finally{setRefreshing(false);}}
  const searchBarLoading = false;
  const [lang, setLang] = useState("");
  const [langId, setLangId] = useState("");


  const [searchingMedList, setSearchingMedList] = useState([]);
  const [activeImg, setActiveImg] = useState([]);
  const [activeVid, setActiveVid] = useState({});
  const [viewVidArr, setViewVidArr] = useState([]);
  const [dosageList, setDosageList] = useState([]);
  const [, setDosageListEn] = useState([]);

  const sortBy = params.get("sort") === "2" ? 2 : 1;
  const setSortBy = value => patchParams({ sort: value, page: 1, focus: null });
  // Dialog
  const [addLangDlg, setAddLangDlg] = useState(false);
  const [mobileVideoDlg, setMobileVideoDlg] = useState(false);
  const [mobileVideoX, setMobileVideoX] = useState([]);
  const setAddMedicineDlg = value => navigate(value ? `${base}/${lang || "en"}/new${listQuery}` : listUrl);
  const [deleteMedicineDlg, setDeleteMedicineDlg] = useState(false);
  const [deleteMedicineBuffer, setDeleteMedicineBuffer] = useState("");
  const setEditMedicineDlg = value => { if (!value) navigate(listUrl); };
  const [editMedicineBuffer, setEditMedicineBuffer] = useState("");

  // LocalData
  const localLangData = JSON.parse(localStorage.getItem("lang"));
  const localAdminData = JSON.parse(localStorage.getItem("adminLoginInfo"));
  // store
  const { langs, activeLang } = useSelector((state) => state.misc);
  const { adminMedicines: medicines, categories, companies, adminVariants: medVariants, seoTags, dosages } =
    useSelector((state) => state.medicine);
  const { admins } = useSelector((state) => state.admin);

  // UseEffect
  // Catalogue language belongs to the URL, independently of the dashboard UI language.
  useEffect(() => {
    const code = routeLanguage || activeLang?.langCode || localLangData?.langCode || "en";
    const selected = langs.find(item => item.langCode === code);
    if (selected) { setLang(code); setLangId(selected._id); }
    if (!routeLanguage && selected) navigate(`${base}/${code}${location.search}`, { replace: true });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [routeLanguage, langs]);

  const catalogueState = useAdminMedicineData();
  const referencesReady = catalogueState.ready;
  const dispatch = useDispatch();
  const enriched = useMemo(() => enrichMedicineCatalogue({medicines, variants: medVariants, categories, companies,
    tags: seoTags, admins, language: lang}), [medicines, medVariants, categories, companies, seoTags, admins, lang]);
  const medList = enriched.selected, medListEn = enriched.english;
  useEffect(() => {setActiveImg(medList.map(item => item.image?.find(image => image.default) || ""));}, [medList]);
  const [details,setDetails] = useState({key:"",medicine:null,error:""}),[detailAttempt,setDetailAttempt]=useState(0);
  useEffect(() => {
    if(reviewActive || !editing || !routeLanguage || !routeEntryId)return;
    const controller=new AbortController(),key=routeLanguage+"/"+routeEntryId;
    setDetails({key,medicine:null,error:""});
    axiosInstance.get(`/api/medicine/details/${routeEntryId}?lang=${routeLanguage}&include=variants&strict=1`,{signal:controller.signal})
      .then(response=>{if(!Array.isArray(response.data.variants))throw new Error('Current medicine variations are unavailable.');if(!controller.signal.aborted)setDetails({key,medicine:response.data.medicine,variants:response.data.variants,error:""});})
      .catch(error=>{if(!controller.signal.aborted)setDetails({key,medicine:null,error:error.response?.data?.message||"This medicine could not be loaded. Please try again."});});
    return()=>controller.abort();
  },[editing,routeLanguage,routeEntryId,detailAttempt,reviewActive]);

  // set Dosage List
  useEffect(() => {
    if (lang !== "" && dosages && dosages.length > 0) {
      const D = {data: medicineReferences(dosages, lang, "dosage")};
      if (D && D.data) setDosageList(D.data);
      else setDosageList([]);
      const DEn = dosages.find((d) => d.lang === "en");
      if (DEn && DEn.data) setDosageListEn(DEn.data);
      else setDosageListEn([]);
    }
  }, [dosages, lang]);

  // Functions
  const handleChangeImage = (i, y) => {
    let arr = [...activeImg];
    arr[i] = y;
    setActiveImg(arr);
  };

  const handleChangeVid = (id, video) => setActiveVid(previous => ({...previous,[id]:video}));
  const videoFor = medicine => activeVid[medicine._id] || medicine.video?.find(video => video.default) || medicine.video?.[0];


  const handleMobileVideo = (vid) => {
    setMobileVideoDlg(true);
    setMobileVideoX(vid);
  };

  // Handle Non Mobile Video
  const handleNonMobileVideo = (id) => {
    let arr = [...viewVidArr];
    if (arr.includes(id)) {
      const index = arr.indexOf(id);
      arr.splice(index, 1);
    } else arr.push(id);
    setViewVidArr(arr);
  };

  // handle Medicine Delete
  const handleMedDelete = (id) => {
    setDeleteMedicineBuffer(id);
    setDeleteMedicineDlg(true);
  };

  // handle Confirm Delete
  const handleConfirmDelete = () => {
    dispatch(
      removeSingleMedicine({
        id: deleteMedicineBuffer,
        expectedRevision: medList.find((m) => m._id === deleteMedicineBuffer)?._revision,
        creatorId: localAdminData._id,
        lang,
      })
    );
    setDeleteMedicineDlg(false);
    setTimeout(() => {
      dispatch(getAdminMedicineCatalogue({force:true}));
      dispatch(getNotification());
    }, 1000);
  };

  // handle Medicine Edit
  const handleMedEdit = (id) => {
    const query = new URLSearchParams(location.search); query.set("focus", id);
    navigate(`${base}/${lang}?${query}`, { replace: true });
    navigate(`${base}/${lang}/${id}/edit?${query}`);
  };
  useEffect(() => {
    if (!referencesReady || !editing || !routeEntryId || editMedicineBuffer?._id === routeEntryId) return;
    const source = reviewSeed?.existing ? { medicine: reviewSeed.content, variants: reviewSeed.variants } : details;
    if ((reviewSeed?.existing || details.key === `${routeLanguage}/${routeEntryId}`) && source.medicine?._id === routeEntryId)
      setEditMedicineBuffer(enrichMedicineCatalogue({medicines:[{lang:routeLanguage,data:[source.medicine]}],variants:source.variants,categories,companies,tags:seoTags,admins,language:routeLanguage}).selected[0]);
  }, [referencesReady, editing, routeLanguage, routeEntryId, medList, editMedicineBuffer, details, reviewSeed, categories, companies, seoTags, admins]);
  useEffect(() => {
    if (!review?.data?.ready || !reviewSeed?.existing || !adding) return;
    navigate(`${base}/${routeLanguage}/${reviewSeed.content._id}/edit${location.search}`, { replace: true });
  }, [review?.data?.ready, reviewSeed, adding, base, routeLanguage, location.search, navigate]);

  // Handle Search
  const handleSearch = (e, newValue) => {
    let arr = [...newValue];
    const unique = [
      ...new Map(arr.map((item) => [item["_id"], item])).values(),
    ];
    let arrImg = [];
    let arrVid = [];
    (unique.length > 0 ? unique : searchMedList).forEach((x) => {
      let obj = { ...x };
      // Setup Image
      if (obj.image && obj.image.length > 0) {
        const I = obj.image.find((i) => i.default === true);
        I ? arrImg.push(I) : arrImg.push("");
      } else arrImg.push("");
      // Setup Video
      if (obj.video && obj.video.length > 0) {
        const V = obj.video.find((i) => i.default === true);
        V ? arrVid.push(V) : arrVid.push("");
      } else arrVid.push("");
    });
    setActiveImg(arrImg);
    setActiveVid(arrVid);

    setSearchingMedList([...unique]);
    patchParams({ selected: unique.length ? unique.map(item => item._id).join(",") : null, page: 1, focus: null });
  };

  // get MEd Name En
  const getMedNameEn = (id) => {
    const M = medListEn.find((m) => m.fixedMedicineId === id);
    if (M) return M.genericBrand;
  };

  // get MEd Generic Name En
  const getMedGenericNameEn = (id) => {
    const M = medListEn.find((m) => m.fixedMedicineId === id);
    if (M) return M.generic;
  };

  // Fixed date
  const [showDate, setShowDate] = useState([]);

  const handleShowDate = (date) => {
    let arr = [...showDate];
    if (arr.includes(date)) {
      arr = arr.filter((a) => a !== date);
    } else {
      arr.push(date);
    }
    setShowDate(arr);
  };

  const getDosageName = (dosageId) => {
    let dosageName = "";
    const D = dosageList.find(
      (d) => (lang !== "en" ? d.dosageDetectorId : d.fixedDosageId) === dosageId
    );
    if (D && D.dosageName) dosageName = D.dosageName;
    return dosageName;
  };

  // ! translate
  const [siteLang, setSiteLang] = useState("en");
  const [langSettings1, setLangSettings1] = useState([]);
  const [langSettings2, setLangSettings2] = useState([]);
  const [langSettings3, setLangSettings3] = useState([]);
  const [langSettings4, setLangSettings4] = useState([]);
  const [langSettings5, setLangSettings5] = useState([]);
  const [langSettings6, setLangSettings6] = useState([]);
  const [langSettings7, setLangSettings7] = useState([]);
  const [langSettings8, setLangSettings8] = useState([]);
  const title1 = "Manage Medicine";
  const title2 = "Misc Words";
  const title3 = "Identification";
  const title4 = "Variation";
  const title5 = "Price Info";
  const title6 = "SEO";
  const title7 = "Actions";
  const title8 = "Additional Section";

  useEffect(() => {
    if (langs && langs.length > 0 && siteLang !== "") {
      const L = langs.find((l) => l.langCode === siteLang);
      let arr = [];
      if (L && L.langSettings && L.langSettings.length > 0)
        arr = L.langSettings;
      else {
        const LEn = langs.find((l) => l.langCode === "en");
        if (LEn && LEn.langSettings && LEn.langSettings.length > 0)
          arr = LEn.langSettings;
      }
      const A = arr.find((l) => l._title === title1);
      if (A) setLangSettings1(A.data);
      const B = arr.find((l) => l._title === title2);
      if (B) setLangSettings2(B.data);
      const C = arr.find((l) => l._title === title3);
      if (C) setLangSettings3(C.data);
      const D = arr.find((l) => l._title === title4);
      if (D) setLangSettings4(D.data);
      const E = arr.find((l) => l._title === title5);
      if (E) setLangSettings5(E.data);
      const F = arr.find((l) => l._title === title6);
      if (F) setLangSettings6(F.data);
      const G = arr.find((l) => l._title === title7);
      if (G) setLangSettings7(G.data);
      const H = arr.find((l) => l._title === title8);
      if (H) setLangSettings8(H.data);
    }
  }, [siteLang, langs]);

  const translate1 = (String) => translation(String, title1, 1);
  const translate2 = (String) => translation(String, title2, 2);
  const translate3 = (String) => translation(String, title3, 3);
  const translate4 = (String) => translation(String, title4, 4);

  const translate6 = (String) => translation(String, title6, 6);
  const translate7 = (String) => translation(String, title7, 7);
  const translate8 = (String) => translation(String, title8, 8);

  const translation = (String, title, index) => {
    let translation = "";
    let settings = [];
    if (index === 1) {
      settings = langSettings1;
    } else if (index === 2) {
      settings = langSettings2;
    } else if (index === 3) {
      settings = langSettings3;
    } else if (index === 4) {
      settings = langSettings4;
    } else if (index === 5) {
      settings = langSettings5;
    } else if (index === 6) {
      settings = langSettings6;
    } else if (index === 7) {
      settings = langSettings7;
    } else if (index === 8) {
      settings = langSettings8;
    }
    const T = settings.find((ls) => ls.title === String);
    if (T && T.value) translation = T.value;
    else {
      let arr = [];
      if (langs && langs.length > 0 && siteLang !== "") {
        const LEn = langs.find((l) => l.langCode === "en");
        if (LEn && LEn.settings && LEn.settings.length > 0) arr = LEn.settings;
        const S = arr.find((l) => l._title === title);
        if (S) {
          const T = S.data.find((ls) => ls.title === String);
          if (T && T.value) translation = T.value;
        }
      }
    }
    return translation || String;
  };

  useEffect(() => {
    setSiteLang(activeLang?.langCode || localLangData?.langCode || "en");
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeLang]);
  // ! translate

  // Pagination
  const totalPage = Math.ceil(medList.length / 12);
  const pageNum = Math.max(1, Math.min(100000, Number.parseInt(params.get("page"), 10) || 1));
  const setPageNum = value => patchParams({ page: value, focus: null });
  const [productViewStart, setProductViewStart] = useState(0);
  const paginateLoading = false;

  const handlePageChange = (event, value) => {
    setPageNum(value);
    // setTimeout(() => {
    // scroll();
    // }, 250);
  };

  useEffect(() => {
    if (pageNum > 1) setProductViewStart((pageNum - 1) * 12);
    else setProductViewStart(0);
  }, [pageNum]);

  // Keep the same keyed cards mounted during reference/data refreshes. Sorting is
  // derived atomically so the list never renders an intermediate unsorted page.
  const searchMedList = useMemo(() => [...medList].sort((a, b) => sortBy === 1
    ? new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime() || String(a._id).localeCompare(String(b._id))
    : a.genericBrand.toLowerCase().replace(/\s/g, "").localeCompare(b.genericBrand.toLowerCase().replace(/\s/g, "")) || String(a._id).localeCompare(String(b._id))), [sortBy, medList]);

  const selectedIds = params.get("selected") || "";
  useEffect(() => {
    const ids = new Set(selectedIds.split(","));
    setSearchingMedList(searchMedList.filter(item => ids.has(item._id)));
  }, [selectedIds, searchMedList]);

  const focusedReturn = useRef(null);
  const focusId = params.get("focus");
  useEffect(() => {
    if (adding || editing || !focusId) { focusedReturn.current = null; return; }
    if (loading || !referencesReady || !focusId || focusedReturn.current === focusId) return;
    const index = searchMedList.findIndex(item => String(item._id) === focusId);
    if (index < 0) return;
    if (selectedIds && !selectedIds.split(",").includes(focusId)) {
      patchParams({ selected: null }, true); return;
    }
    const destinationPage = Math.floor(index / 12) + 1;
    if (!selectedIds && pageNum !== destinationPage) {
      patchParams({ page: destinationPage }, true); return;
    }
    const frame = requestAnimationFrame(() => {
      const card = document.getElementById(`medicine-card-${focusId}`);
      if (!card) return;
      card.scrollIntoView({ block: "start", behavior: "auto" });
      card.focus({ preventScroll: true });
      focusedReturn.current = focusId;
    });
    return () => cancelAnimationFrame(frame);
  // Query changes are deliberately driven by the focus target, not object identity.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [adding, editing, loading, referencesReady, focusId, searchMedList, selectedIds, pageNum, productViewStart, location.key]);

  //! Translate
  // Store
  const { langArrFromClientSide } = useSelector((state) => state.misc);
  const translate0 = (String) => {
    let translation = "";
    if (langArrFromClientSide && langArrFromClientSide.length > 0) {
      const T = langArrFromClientSide.find((l) => l.title === String);
      if (T && T.value) {
        let obj = { ...T };
        if (T.value === "") obj.value = T.title;
        translation = T.value;
      } else if (T === undefined) translation = String;
    }
    return translation || String;
  };
  //! Translate

  if (routeLanguage && langs.length && !langs.some(item => item.langCode === routeLanguage)) {
    return <Box><Typography>Language not found.</Typography><Button component={Link} to={base}>Back to medicines</Button></Box>;
  }
  if (!referencesReady && catalogueState.error) return <Alert severity="error" action={<Button onClick={catalogueState.retry}>Try again</Button>}>{catalogueState.error}</Alert>;
  if (adding && medicineWorkspace?.draftSessionPending) return <LoadingBox w="100%" h={200} />;
  if (review && !review.data?.ready && (review.error || recoverableMedicineStatuses.has(review.data?.status))) return <Box aria-label="Medicine content generation progress"><MedicineLanguageTabs /><MedicineAiRecovery {...medicineWorkspace.aiRecovery} /><Button color="warning" onClick={() => medicineWorkspace.openSavedMedicine(true)}>Discard this language draft</Button></Box>;
  if (review && (review.loading || !review.data?.ready || !reviewSeed)) return <Box aria-label="Medicine content generation progress" sx={{ minWidth: 0 }}><MedicineLanguageTabs /><Box sx={{ p: 3 }}><Typography variant="h6" sx={{ mb: 1 }}>Preparing medicine fields</Typography><LinearProgress variant={review.data ? 'determinate' : 'indeterminate'} value={review.data?.progress || 0} /><Typography sx={{ mt: 1 }}>{review.data?.progress || 0}% · {review.data?.stage || 'Loading the saved generation…'}</Typography><Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>This work continues in the background. Generated content will open in the normal medicine form for review. Nothing is saved or published until you use the form’s Add or Update button.</Typography></Box></Box>;
  if (adding && !referencesReady) return <LoadingBox w="100%" h={300} />;
  if (adding && lang && lang === routeLanguage) return <AddMedicineDialog key={`new-${lang}`} page
    sourceEntryId={params.get("source")} addMedicineDlg setAddMedicineDlg={setAddMedicineDlg} lang={lang} langId={langId} medListEn={medListEn}
    onSaved={(result, receipt) => { const query = new URLSearchParams(location.search); const researchId=query.get("research");if(researchId)axiosInstance.post(`/api/translations/research/runs/${researchId}/attach`,{sourceId:String(result.medicineId)}).catch(()=>{}); query.set("focus", result.medicineId); navigate(`${base}/${lang}/${result.medicineId}/edit?${query}`, { replace: true, state: { medicineReceipt: receipt } }); }} />;
  if (editing) {
    if(details.error) return <Box><MedicineSaveFeedback receipt={location.state?.medicineReceipt}/><Alert severity="error" action={<Button onClick={()=>setDetailAttempt(value=>value+1)}>Try again</Button>}>{details.error}</Alert></Box>;
    if (!referencesReady || lang !== routeLanguage || (loading && editMedicineBuffer?._id !== routeEntryId)) return <LoadingBox w="100%" h={300} />;
    if (editMedicineBuffer?._id !== routeEntryId) return <LoadingBox w="100%" h={300} />;
    return <EditMedicineDialog key={routeEntryId} page editMedicineDlg setEditMedicineDlg={setEditMedicineDlg}
      lang={lang} langId={langId} medListEn={medListEn} editMedicineBuffer={editMedicineBuffer}
      setEditMedicineBuffer={setEditMedicineBuffer} initialReceipt={location.state?.medicineReceipt} />;
  }
  return (
    <Box sx={{ width: "100%", minWidth: 0 }}>
      {langs.length > 0 && (
        <>
          <PageHeader
            title={
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                {translate1("Medicines")}
                <Chip
                  label={medList.length}
                  size="small"
                  sx={{
                    bgcolor: colors.primary,
                    color: colors.white,
                    fontWeight: 700,
                  }}
                />
              </Box>
            }
            action={
              <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
                <Button size="small" variant="outlined" aria-label="Refresh medicine list" disabled={refreshing} onClick={refreshCatalogue}>{refreshing?"Refreshing…":"Refresh list"}</Button>
                <Tooltip title="Add Language" arrow placement="top">
                  <IconButton size="small" onClick={() => setAddLangDlg(true)}>
                    <AddCircleOutlineOutlinedIcon color="info" />
                  </IconButton>
                </Tooltip>
                <AddLangDialog
                  addLangDlg={addLangDlg}
                  setAddLangDlg={setAddLangDlg}
                  setLang={setLang}
                />

                <Button
                  variant="contained"
                  size="small"
                  color="primary"
                  onClick={() => setAddMedicineDlg(true)}
                >
                  {translate1("Add Medicine")}
                </Button>

              </Box>
            }
          />
          {refreshError&&<Alert severity="warning" sx={{mb:2}}>{refreshError}</Alert>}
          <TranslationCatalogue language={lang} />
          {/* Search */}
          <Box sx={{ mb: 2 }}>
            {!searchBarLoading && (
              <SearchFilterBar
                multiple
                value={searchingMedList}
                options={searchMedList}
                onChange={(e, newValue) => handleSearch(e, newValue)}
                optionsLimit={50}
                label={translate1("Search") + "..."}
                getOptionLabel={(option) =>
                  `${option.genericBrand} (${option.generic}) ${
                    lang !== "en"
                      ? " - " +
                        getMedNameEn(option.medicineDetectorId) +
                        " (" +
                        getMedGenericNameEn(option.medicineDetectorId) +
                        ")"
                      : ""
                  }`
                }
                renderOption={(props, option) => (
                  <Box
                    component="li"
                    sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                    {...props}
                  >
                    <img
                      loading="lazy"
                      width="20"
                      src={
                        option.image.length > 0
                          ? option.image
                              .find((i) => i.default)
                              .src.includes("http")
                            ? option.image.find((i) => i.default).src
                            : PF +
                              "adminPanel/medicines/img/" +
                              option.image.find((i) => i.default).src
                          : PF + "adminPanel/medicines/no-medicine-image.jpg"
                      }
                      alt="admins"
                    />
                    {option.genericBrand} {" (" + option.generic + ") "}
                    {lang !== "en"
                      ? " - " + getMedNameEn(option.medicineDetectorId)
                      : ""}
                    {lang !== "en"
                      ? " (" +
                        getMedGenericNameEn(option.medicineDetectorId) +
                        ")"
                      : ""}
                  </Box>
                )}
              />
            )}
          </Box>
          {/* Sort */}
          <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
            <FormControl size="small" sx={{ minWidth: 180 }}>
              <InputLabel id="demo-simple-select-label">
                {translate0("Sort")}
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={sortBy}
                label={translate0("Sort")}
                onChange={(e) => setSortBy(e.target.value)}
              >
                <MenuItem value={1}>{translate0("Creation")}</MenuItem>
                <MenuItem value={2}>{translate0("Generic Brand")}</MenuItem>
              </Select>
            </FormControl>
          </Box>
          {!paginateLoading &&
            totalPage >= 1 &&
            // !medList.includes("null") &&
            !searchingMedList.length > 0 &&
            medList.length > 0 && (
              <Grid
                item
                xs={12}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  width: "100%",
                  mt: 2,
                }}
              >
                <Stack spacing={2}>
                  <Pagination
                    aria-label="Medicine pages at top"
                    page={pageNum}
                    count={Math.max(1, Math.ceil(searchMedList.length / 12))}
                    color="primary"
                    onChange={handlePageChange}
                    size={smUp ? "medium" : "small"}
                    hideNextButton={smUp ? false : true}
                    hidePrevButton={smUp ? false : true}
                  />
                </Stack>
              </Grid>
            )}
          <Box
            sx={{
              minWidth: 0,
              overflowWrap: "anywhere",
              mt: 3,
              bgcolor: colors.paperTint,
              borderRadius: radii.lg,
              p: { xs: 1, sm: 1.5 },
            }}
          >
            {(loading || !referencesReady) && medList.length === 0 ? (
              <LoadingBox w={"100%"} h={300} />
            ) : medList.length < 1 ? (
              <EmptyStateAlert message={translate2("No Medicine Available")} />
            ) : (
              (searchingMedList.length > 0
                ? searchingMedList
                : searchMedList.slice(productViewStart, productViewStart + 12)
              ).map((x, i) => (
                <Box
                  key={x._id} id={`medicine-card-${x._id}`} tabIndex={-1}
                  sx={{
                    scrollMarginTop: 88,
                    outline: String(x._id) === focusId ? "2px solid" : "none",
                    outlineColor: "primary.main",
                    bgcolor: colors.white,
                    border: `1px solid ${colors.line}`,
                    borderRadius: radii.lg,
                    boxShadow: shadows.card,
                    p: { xs: 2, sm: 2.5 },
                    mb: 2.5,
                  }}
                >
                  {/* Header: thumbnail + identity + actions */}
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm="auto">
                      <Box
                        sx={{
                          width: 84,
                          height: 84,
                          borderRadius: radii.md,
                          border: `1px solid ${colors.line}`,
                          bgcolor: colors.paperTint,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          overflow: "hidden",
                          flexShrink: 0,
                        }}
                      >
                        <LazyLoadImage
                          effect="blur"
                          src={
                            x.image && x.image.length > 0
                              ? x.image[0]?.src !== "" &&
                                PF +
                                  "adminPanel/medicines/img/" +
                                  x.image[0].src
                              : PF + "adminPanel/medicines/blank.jpg"
                          }
                          alt={
                            x.image && x.image.length > 0
                              ? x.image[0]?.alt !== "" && x.image[0]?.alt
                              : "no-image"
                          }
                          title={
                            x.image && x.image.length > 0
                              ? x.image[0]?.alt !== "" && x.image[0]?.alt
                              : "no-image"
                          }
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </Box>
                      {x.image.length > 1 && (
                        <Box
                          sx={{
                            display: "flex",
                            gap: 0.5,
                            mt: 0.75,
                            flexWrap: "wrap",
                            maxWidth: 84,
                          }}
                        >
                          {x.image.map(
                            (y, j) =>
                              j < 4 && (
                                <Box
                                  key={j}
                                  component="img"
                                  src={PF + "adminPanel/medicines/img/" + y.src}
                                  alt={y.alt}
                                  title={y.alt}
                                  onClick={() => handleChangeImage(i, y)}
                                  sx={{
                                    width: 18,
                                    height: 18,
                                    objectFit: "cover",
                                    borderRadius: "4px",
                                    cursor: "pointer",
                                    border: `1px solid ${colors.line}`,
                                  }}
                                />
                              )
                          )}
                        </Box>
                      )}
                    </Grid>
                    <Grid item xs>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                          flexWrap: "wrap",
                        }}
                      >
                        <Typography
                          sx={{
                            fontFamily: fonts.display,
                            fontWeight: 800,
                            fontSize: "1.05rem",
                            color: colors.ink,
                          }}
                        >
                          {String(x.genericBrand || "").toUpperCase()}
                        </Typography>
                        {x.prescribed && (
                          <Chip label="Rx" size="small" color="error" />
                        )}
                        <Tooltip title="View on site" arrow placement="top">
                          <IconButton
                            size="small"
                            onClick={() =>
                              window.open(
                                (window.location.hostname === "localhost"
                                  ? "http://localhost:3000"
                                  : "https://" + window.location.hostname) +
                                  buildFrontendUrl(
                                    lang,
                                    "/our-medicines/" +
                                      makeUrlFriendly(
                                        lang !== "en"
                                          ? getMedNameEn(x.medicineDetectorId)
                                          : x.genericBrand
                                      )
                                  ),
                                "_blank"
                              )
                            }
                          >
                            <CallMadeIcon fontSize="small" color="info" />
                          </IconButton>
                        </Tooltip>
                        {lang !== "en" && (
                          <Tooltip
                            arrow
                            title={`English Variant: ${getMedNameEn(
                              x.medicineDetectorId
                            )}`}
                            placement="top"
                          >
                            <IconButton size="small">
                              <Info color="info" fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        )}
                      </Box>
                      <Typography sx={{ fontSize: 13.5, color: colors.ink3, mt: 0.25 }}>
                        {translate3("Generic")}: {String(x.generic || "").toUpperCase()}
                      </Typography>
                      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.75, mt: 1 }}>
                        {x.catsArr &&
                          x.catsArr.length > 0 &&
                          x.catsArr.map(
                            (y, j) =>
                              y.catName && (
                                <Chip
                                  key={j}
                                  label={String(y.catName || "").toUpperCase()}
                                  size="small"
                                  sx={{ bgcolor: colors.primaryLight, color: colors.primary, fontWeight: 600 }}
                                />
                              )
                          )}
                        {x.subCatsArr &&
                          x.subCatsArr.length > 0 &&
                          x.subCatsArr.map((y, j) => (
                            <Chip
                              key={j}
                              label={String(y || "").toUpperCase()}
                              size="small"
                              variant="outlined"
                            />
                          ))}
                        <Chip
                          label={
                            x.stock > 0
                              ? translate4("Available") || "Available"
                              : translate4("Out Of Stock") || "Out Of Stock"
                          }
                          size="small"
                          color={x.stock > 0 ? "success" : "error"}
                          variant="outlined"
                        />
                      </Box>
                    </Grid>
                    <Grid item xs="auto">
                      <Box sx={{ display: "flex", gap: 0.5 }}>
                        <IconButton aria-label={`Edit medicine ${x.genericBrand}`} onClick={() => handleMedEdit(x._id)}>
                          <EditRoundedIcon color="primary" />
                        </IconButton>
                        <IconButton onClick={() => handleMedDelete(x._id)}>
                          <DeleteRoundedIcon color="error" />
                        </IconButton>
                      </Box>
                    </Grid>
                  </Grid>

                  <Divider sx={{ my: 2 }} />

                  {/* Key facts */}
                  <Grid container spacing={2}>
                    <Grid item xs={6} sm={3}>
                      <Typography sx={{ fontSize: 11.5, fontWeight: 700, color: colors.ink3, textTransform: "uppercase" }}>
                        {translate3("Local Company")}
                      </Typography>
                      <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, mt: 0.25 }}>
                        <Typography sx={{ fontSize: 13.5, fontWeight: 600, color: colors.ink }}>
                          {x.company && String(x.company.companyName || "").toUpperCase()}
                        </Typography>
                        {x.company && (
                          <img
                            src={PF + "/adminPanel/companies/" + x.company.companyLogo}
                            alt={x.company && x.company.companyName}
                            style={{ height: "16px", objectFit: "cover", borderRadius: "4px" }}
                          />
                        )}
                      </Box>
                    </Grid>
                    <Grid item xs={6} sm={3}>
                      <Typography sx={{ fontSize: 11.5, fontWeight: 700, color: colors.ink3, textTransform: "uppercase" }}>
                        {translate3("Originator")}
                      </Typography>
                      <Typography sx={{ fontSize: 13.5, fontWeight: 600, color: colors.ink, mt: 0.25 }}>
                        {String(x.originator || "").toUpperCase()}
                      </Typography>
                    </Grid>
                    <Grid item xs={6} sm={3}>
                      <Typography sx={{ fontSize: 11.5, fontWeight: 700, color: colors.ink3, textTransform: "uppercase" }}>
                        {translate4("Dosage Form")}
                      </Typography>
                      <Typography sx={{ fontSize: 13.5, fontWeight: 600, color: colors.ink, mt: 0.25 }}>
                        {x.variantInfo &&
                          x.variantInfo.length > 0 &&
                          x.variantInfo.map(
                            (y, j) =>
                              getDosageName(y.dosageForm).toUpperCase() +
                              (x.variantInfo.length > 1 &&
                              j < x.variantInfo.length - 1
                                ? ", "
                                : "")
                          )}
                      </Typography>
                      <Typography sx={{ fontSize: 12, color: colors.ink3, mt: 0.25 }}>
                        {x.variantInfo &&
                          x.variantInfo.length > 0 &&
                          x.variantInfo.map(
                            (y, j) =>
                              y.strength &&
                              String(y.strength || "").toUpperCase() +
                                (x.variantInfo.length > 1 &&
                                j < x.variantInfo.length - 1
                                  ? ", "
                                  : "")
                          )}
                        {" · "}
                        {x.variantInfo &&
                          x.variantInfo.length > 0 &&
                          x.variantInfo.map(
                            (y, j) =>
                              y.packTypes &&
                              formatMedicinePackSize(y.packTypes) +
                                (x.variantInfo.length > 1 &&
                                j < x.variantInfo.length - 1
                                  ? ", "
                                  : "")
                          )}
                      </Typography>
                    </Grid>
                  </Grid>

                  {/* Price Info */}
                  {x.variantInfo && x.variantInfo.length > 0 && (
                    <PriceInfoPanel data={x.variantInfo} lang={lang} />
                  )}

                  {/* Video Section */}
                  {x.video && x.video.length > 0 && (
                  <Box sx={{ mt: 2 }}>
                    {!smUp ? (
                      //  Mobile
                      <Button
                        variant="outlined"
                        size="small"
                        color="secondary"
                        onClick={() => handleMobileVideo(x)}
                      >
                        {translate1("Video")}
                      </Button>
                    ) : (
                      // Pc
                      <Accordion
                        disableGutters
                        expanded={viewVidArr.includes(x._id)}
                        onChange={() => handleNonMobileVideo(x._id)}
                        sx={{ boxShadow: "none", border: `1px solid ${colors.line}`, borderRadius: radii.md, "&:before": { display: "none" } }}
                      >
                        <AccordionSummary expandIcon={<ExpandMore />}>
                          <SectionLabelChip label={translate1("Video")} />
                        </AccordionSummary>
                        <AccordionDetails>
                          <Grid container spacing={0} flexDirection="column">
                            {videoFor(x) && videoFor(x) !== "" && (
                              <Grid item sx={{ mb: 1, width: "100%", maxWidth: 360 }}>
                                <CustomVideoPlayer
                                  url={
                                    videoFor(x).externalLink
                                      ? videoFor(x).src
                                      : PF +
                                        "adminPanel/medicines/vid/" +
                                        videoFor(x).src
                                  }
                                  height={!mdUp ? 190 : 220}
                                />
                              </Grid>
                            )}
                            <Grid item>
                              <Grid container spacing={1}>
                                {x.video &&
                                  x.video.map((y, j) => (
                                    <Grid item key={j}>
                                      <>
                                        {j < 4 && (
                                          <>
                                            {y.externalLink ? (
                                              <ReactPlayer
                                                url={y.src}
                                                controls
                                                muted
                                                height="40px"
                                                width={!mdUp ? "40px" : "50px"}
                                                onPlay={() =>
                                                  handleChangeVid(x._id, y)
                                                }
                                              />
                                            ) : (
                                              <CardMedia
                                                component="video"
                                                sx={{
                                                  height: "40px",
                                                  width: !mdUp ? "40px" : "80px",
                                                }}
                                                image={
                                                  PF +
                                                  "adminPanel/medicines/vid/" +
                                                  y.src
                                                }
                                                // controls
                                                muted
                                                onClick={() =>
                                                  handleChangeVid(x._id, y)
                                                }
                                              />
                                            )}{" "}
                                          </>
                                        )}
                                      </>
                                    </Grid>
                                  ))}
                              </Grid>
                            </Grid>
                          </Grid>
                        </AccordionDetails>
                      </Accordion>
                    )}
                  </Box>
                  )}

                  {/* SEO Section */}
                  <Accordion disableGutters TransitionProps={{unmountOnExit:true}} sx={{ mt: 2, boxShadow: "none", border: `1px solid ${colors.line}`, borderRadius: radii.md, "&:before": { display: "none" } }}>
                    <AccordionSummary expandIcon={<ExpandMore />}>
                      <SectionLabelChip label={translate2("SEO")} />
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid container spacing={1.5}>
                        <Grid item xs={12} sm={4}>
                          <Typography sx={{ fontSize: 11.5, fontWeight: 700, color: colors.ink3, textTransform: "uppercase" }}>
                            {translate6("Meta Keyword")}
                          </Typography>
                          <Typography sx={{ fontSize: 12.5, color: colors.ink2 }}>
                            {x.metaKeyword && x.metaKeyword}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <Typography sx={{ fontSize: 11.5, fontWeight: 700, color: colors.ink3, textTransform: "uppercase" }}>
                            {translate6("Meta Title")}
                          </Typography>
                          <Typography sx={{ fontSize: 12.5, color: colors.ink2 }}>
                            {x.metaTitle && x.metaTitle}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <Typography sx={{ fontSize: 11.5, fontWeight: 700, color: colors.ink3, textTransform: "uppercase" }}>
                            {translate6("Meta Description")}
                          </Typography>
                          <Typography sx={{ fontSize: 12.5, color: colors.ink2 }}>
                            {x.metaDesc &&
                              x.metaDesc.replace(
                                "medicineforworld@gmail.com",
                                "info@elifesavingmedicine.com"
                              )}
                          </Typography>
                        </Grid>
                        <Grid item xs={12}>
                          <Typography sx={{ fontSize: 11.5, fontWeight: 700, color: colors.ink3, textTransform: "uppercase", mb: 0.5 }}>
                            {translate6("Tags")}
                          </Typography>
                          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.75 }}>
                            {x.tagsArr &&
                              x.tagsArr.map((y, j) => (
                                <Tooltip key={j} title={y.tagDetails} arrow placement="top">
                                  <Chip size="small" color={y.severity} label={y.tagName} />
                                </Tooltip>
                              ))}
                          </Box>
                        </Grid>
                      </Grid>
                    </AccordionDetails>
                  </Accordion>

                  {/* Clinical content is requested only when this card is opened. */}
                  <Accordion disableGutters TransitionProps={{unmountOnExit:true}} sx={{mt:2,boxShadow:"none",border:`1px solid ${colors.line}`,borderRadius:radii.md,"&:before":{display:"none"}}}>
                    <AccordionSummary expandIcon={<ExpandMore/>}><SectionLabelChip label={translate2("Additional Section")}/></AccordionSummary>
                    <AccordionDetails><MedicineAdditionalPreview medicineId={x._id} language={lang} revision={x._revision} translate={translate8}/></AccordionDetails>
                  </Accordion>

                  {/* Meta footer */}
                  {(x.creatorName || x.createdAt || x.updatedAt) && (
                    <>
                      <Divider sx={{ my: 2 }} />
                      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
                        {x.creatorName && (
                          <Typography sx={{ fontSize: 12, color: colors.ink3 }}>
                            {translate2("Created By")}:{" "}
                            <Typography component="span" sx={{ fontSize: 12, fontWeight: 600, color: colors.ink2 }}>
                              {String(x.creatorName || "").toUpperCase()}
                            </Typography>
                          </Typography>
                        )}
                        {x.createdAt && (
                          <Typography sx={{ fontSize: 12, color: colors.ink3 }}>
                            {translate7("Created")}:{" "}
                            <Typography component="span" sx={{ fontSize: 12, fontWeight: 600, color: colors.primary }}>
                              {formatDistance(new Date(x.createdAt), new Date(), { addSuffix: true })}
                            </Typography>
                            <Tooltip arrow placement="top" title={getExactTime(x.createdAt)}>
                              <IconButton size="small" onClick={() => handleShowDate(x.createdAt)}>
                                <InfoIcon color="info" sx={{ fontSize: 14 }} />
                              </IconButton>
                            </Tooltip>
                            {showDate.includes(x.createdAt) && (
                              <Typography component="span" sx={{ fontSize: 11, color: colors.ink3, display: "block" }}>
                                {getExactTime(x.createdAt)}
                              </Typography>
                            )}
                          </Typography>
                        )}
                        {x.updatedAt && (
                          <Typography sx={{ fontSize: 12, color: colors.ink3 }}>
                            {translate2("Updated")}:{" "}
                            <Typography component="span" sx={{ fontSize: 12, fontWeight: 600, color: colors.ink2 }}>
                              {formatDistance(new Date(x.updatedAt), new Date(), { addSuffix: true })}
                            </Typography>
                            <Tooltip arrow placement="top" title={getExactTime(x.updatedAt)}>
                              <IconButton size="small" onClick={() => handleShowDate(x.updatedAt)}>
                                <InfoIcon color="info" sx={{ fontSize: 14 }} />
                              </IconButton>
                            </Tooltip>
                            {showDate.includes(x.updatedAt) && (
                              <Typography component="span" sx={{ fontSize: 11, color: colors.ink3, display: "block" }}>
                                {getExactTime(x.updatedAt)}
                              </Typography>
                            )}
                          </Typography>
                        )}
                      </Box>
                    </>
                  )}
                </Box>
              ))
            )}
          </Box>
          {!paginateLoading &&
            totalPage >= 1 &&
            // !medList.includes("null") &&
            !searchingMedList.length > 0 &&
            medList.length > 0 && (
              <Grid
                item
                xs={12}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  width: "100%",
                  mt: 2,
                }}
              >
                <Stack spacing={2}>
                  <Pagination
                    aria-label="Medicine pages at bottom"
                    page={pageNum}
                    count={Math.max(1, Math.ceil(searchMedList.length / 12))}
                    color="primary"
                    onChange={handlePageChange}
                    size={smUp ? "medium" : "small"}
                    hideNextButton={smUp ? false : true}
                    hidePrevButton={smUp ? false : true}
                  />
                </Stack>
              </Grid>
            )}
        </>
      )}
      {/* mobile video dialog */}
      <MedicineVideoDialog
        mobileVideoDlg={mobileVideoDlg}
        setMobileVideoDlg={setMobileVideoDlg}
        x={mobileVideoX}
      />
      {/* Delete Medicine Dialog */}
      <Dialog
        open={deleteMedicineDlg}
        onClose={() => {
          setDeleteMedicineDlg(false);
          setDeleteMedicineBuffer("");
        }}
      >
        <DialogContent>
          <DialogContentText>
            {translate7("Are you sure you want to delete this medicine?")}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setDeleteMedicineDlg(false);
              setDeleteMedicineBuffer("");
            }}
            color="primary"
          >
            Cancel
          </Button>
          <Button onClick={handleConfirmDelete} color="error">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

    </Box>
  );
}
